<template>
  <div class="col-12">
    <div class="card card-panel-title-center shadow-none">
      <div
        class="card-header p-0 d-flex justify-content-center border-0 flex-column"
      >
        <p>Hourly Current (mA)</p>
        <!-- <h3>Daily Data generated at : 24-10-2024 8:21:14 AM</h3> -->
      </div>
      <div class="card-body p-0 row gap-2">
        <div class="col h-100 p-0">
          <Line id="my-chart-id" :options="chartOptions" :data="chartData" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
export default {
  components: { Line },
  props: ["items"],
  computed: {
    chartData() {
      return {
        datasets: [
          {
            backgroundColor: "#218863",
            pointBorderColor: "#218863",
            borderColor: "#BCEFDB",
            fill: false,
            data: this.items?.Data,
            id: "current",
            label: "",
            yAxisID: "y",
            lineTension: 0.4,
          },
        ],
        labels: this.items?.Label,
      };
    },
    chartOptions() {
      return {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false,
        },
        stacked: false,
        plugins: {
          title: {
            display: false,
            text: "Chart.js Line Chart - Multi Axis",
          },
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "left",
            title: { display: false, text: "°C" },
            min: 0,
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.card-panel-title-center {
  height: 300px;
}
p {
  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
h3 {
  color: #aeaeae;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>